<div class="service--box__icon-box"
     [ngClass]="[key(), size()]">
    <div class="material-symbols-outlined">{{ icon() }}</div>
</div>
